function toggleCustomCollapse(element) {
  var container = element.closest(".custom-collapse--container");
  var content = container.querySelector(".custom-collapse--content");
  var sectionContainer = element.closest(".section--custom-faq--container");
  if (sectionContainer == null) {
    sectionContainer = element.closest("product-info");
  }
  if (sectionContainer == null) {
    sectionContainer = element.closest(
      ".section--custom-featured-product--container"
    );
  }
  if (container.classList.contains("open") == false) {
    if (sectionContainer.querySelector(".custom-collapse--container.open")) {
      sectionContainer.querySelector(
        ".custom-collapse--container.open .custom-collapse--content"
      ).style.maxHeight = 0;
      sectionContainer
        .querySelector(".custom-collapse--container.open")
        .classList.remove("open");
    }
    container.classList.add("open");
    content.style.maxHeight = content.scrollHeight + "px";
  } else {
    container.classList.remove("open");
    content.style.maxHeight = 0;
  }
}

function changePrice() {
  let priceDiv = document.querySelector(
    ".kaching-bundles .kaching-bundles__bar :checked+.kaching-bundles__bar-container .kaching-bundles__bar-price"
  );
  let comparePriceDiv = document.querySelector(
    ".kaching-bundles .kaching-bundles__bar :checked+.kaching-bundles__bar-container .kaching-bundles__bar-full-price"
  );
  if (priceDiv != null && comparePriceDiv != null) {
    var price = document.querySelector(
      ".kaching-bundles .kaching-bundles__bar :checked+.kaching-bundles__bar-container .kaching-bundles__bar-price"
    ).textContent;
    var comparePrice = document.querySelector(
      ".kaching-bundles .kaching-bundles__bar :checked+.kaching-bundles__bar-container .kaching-bundles__bar-full-price"
    ).textContent;

    // var unit = price[0];
    let moneyFormat = document
      .getElementById("currency-info")
      .getAttribute("data-currency-symbol");
    // console.log(moneyFormat, "moneyFormat--");

    // Regex to extract the currency symbol (either at the start or the end)
    // let regex = /^[^\s{]+|[^\s{]+(?=\s*$)/;
    let regex = /^[^\s{}]+|[^\s{}]+(?=[\s{}]*$)/;

    // Extract the currency symbol
    let match = moneyFormat.match(regex);
    let currencySymbol = match ? match[0] : null;
    // console.log(currencySymbol, "currencySymbol--");

    // Determine the position of the currency symbol (start or end)
    let currencyPosition;
    if (moneyFormat.startsWith(currencySymbol)) {
      currencyPosition = "start";
    } else if (moneyFormat.endsWith(currencySymbol)) {
      currencyPosition = "end";
    } else {
      currencyPosition = "unknown";
    }
    // console.log(currencyPosition, "currencyPosition--");

    let splitRegex = new RegExp(`\\s*${currencySymbol}\\s*`);
    let [leftPart, rightPart] = moneyFormat.split(splitRegex);

    // Only trim and check for spaces if the format had spaces around the symbol
    let finalSymbol = currencySymbol;
    console.log(finalSymbol, "finalSymbol--");
    if (/\s/.test(moneyFormat)) {
      leftPart = leftPart ? leftPart.trim() : "";
      rightPart = rightPart ? rightPart.trim() : "";

      // Example of how you might use the left and right parts
      if (leftPart) {
        finalSymbol = " " + currencySymbol;
      }
      if (rightPart) {
        finalSymbol = currencySymbol + " ";
      }
    }

    let unit = finalSymbol;
    // console.log(unit, "unit--");

    price = parseFloat(price.replace(/\D/g, ""));
    comparePrice = parseFloat(comparePrice.replace(/\D/g, ""));
    savedPrice = comparePrice - price;
    savedPrice = savedPrice / 100;
    savedPrice = savedPrice.toFixed(2);

    price = price / 100;
    price = price.toFixed(2);

    comparePrice = comparePrice / 100;
    comparePrice = comparePrice.toFixed(2);

    console.log(unit, price, comparePrice, savedPrice);

    if (currencyPosition === "start") {
      document.querySelector(".custom-price-item--regular").textContent =
        unit + comparePrice;
    } else if (currencyPosition === "end") {
      document.querySelector(".custom-price-item--regular").textContent =
        comparePrice + unit;
    }

    Array.from(document.querySelectorAll(".custom-price-item--last")).forEach(
      (element) => {
        if (currencyPosition === "start") {
          element.textContent = unit + price;
        } else if (currencyPosition === "end") {
          element.textContent = price + unit;
        }
      }
    );
    if (currencyPosition === "start") {
      document.querySelector("#custom-saved-price").textContent =
        unit + savedPrice;
    } else if (currencyPosition === "end") {
      document.querySelector("#custom-saved-price").textContent =
        savedPrice + unit;
    }
    // let moneyFormat = document
    //   .getElementById("currency-info")
    //   .getAttribute("data-currency-symbol");
    // console.log(moneyFormat, "moneyFormat--");

    // let regex = /^[^\s{]+|[^\s{]+(?=\s*$)/;

    // // Extract the currency symbol
    // let match = moneyFormat.match(regex);
    // let currencySymbol = match ? match[0] : null;
    // console.log(currencySymbol);

    // let unit = currencySymbol;
    // console.log(unit, "unit--");

    // price = parseFloat(price.replace(/\D/g, ""));
    // comparePrice = parseFloat(comparePrice.replace(/\D/g, ""));
    // savedPrice = comparePrice - price;
    // console.log(unit, price, comparePrice, savedPrice);
    // document.querySelector(".custom-price-item--regular").textContent =
    //   unit + comparePrice / 100;
    // Array.from(document.querySelectorAll(".custom-price-item--last")).forEach(
    //   (element) => {
    //     element.textContent = unit + price / 100;
    //   }
    // );
    // document.querySelector("#custom-saved-price").textContent =
    //   unit + savedPrice / 100;
  }
}

document.addEventListener("DOMContentLoaded", function () {
  var elements = document.querySelectorAll(".custom-collapse--header");
  Array.from(elements).forEach((element) => {
    element.addEventListener("click", () => {
      toggleCustomCollapse(element);
    });
  });

  changePrice();
  Array.from(
    document.querySelectorAll(".kaching-bundles__bar-container")
  ).forEach((element) => {
    element.addEventListener("click", () => {
      setTimeout(() => {
        changePrice();
      }, 500);
    });
  });
});

function changeLogo() {
  let moneyFormat = document
    .getElementById("currency-info")
    .getAttribute("data-currency-symbol");
  // console.log(moneyFormat, "moneyFormat--");

  // Regex to extract the currency symbol (either at the start or the end)
  let regex = /^[^\s{]+|[^\s{]+(?=\s*$)/;

  // Extract the currency symbol
  let match = moneyFormat.match(regex);
  let currencySymbol = match ? match[0] : null;
  // console.log(currencySymbol, "currencySymbol--");

  // Determine the position of the currency symbol (start or end)
  let currencyPosition;
  if (moneyFormat.startsWith(currencySymbol)) {
    currencyPosition = "start";
  } else if (moneyFormat.endsWith(currencySymbol)) {
    currencyPosition = "end";
  } else {
    currencyPosition = "unknown";
  }
  // console.log(currencyPosition, "currencyPosition--");

  let splitRegex = new RegExp(`\\s*${currencySymbol}\\s*`);
  let [leftPart, rightPart] = moneyFormat.split(splitRegex);

  // Only trim and check for spaces if the format had spaces around the symbol
  let finalSymbol = currencySymbol;
  if (/\s/.test(moneyFormat)) {
    leftPart = leftPart ? leftPart.trim() : "";
    rightPart = rightPart ? rightPart.trim() : "";

    // Example of how you might use the left and right parts
    if (leftPart) {
      finalSymbol = " " + currencySymbol;
    }
    if (rightPart) {
      finalSymbol = currencySymbol + " ";
    }
  }
  let currency = finalSymbol;

  if (currencyPosition === "start") {
    document.querySelectorAll(".bundle_logo").forEach((element) => {
      element.innerHTML = currency;
    });
    document.querySelectorAll(".bundle_logo_end").forEach((hideother) => {
      hideother.display = "none";
    });
  } else if (currencyPosition === "end") {
    document.querySelectorAll(".bundle_logo_end").forEach((element) => {
      element.innerHTML = currency;
    });
    document.querySelectorAll(".bundle_logo").forEach((hideother) => {
      hideother.display = "none";
    });
  }
}
changeLogo();
